import { InputComponentMetadata } from "@eavfw/quickform-core"; 
import { EmailProperties } from "./EmailInput";

export const emailInputSchema: InputComponentMetadata<EmailProperties> = {
    label: "Email",
    uiSchema: {
        paragraph: {
            "ui:widget": "textarea"
        }
    },
    schema: {
        type: "object",

        properties: {
            text: {
                title: "Text",
                type: "string"
            },
            placeholder: {
                title: "Placeholder",
                type: "string"
            },
            paragraph: {
                title: "Paragraph",
                type: "string"
            },
            beforeIcon: {
                enum: [
                    "Phone",
                    "Email",
                    "User"
                ],
                // @ts-ignore
                "enumNames": [
                    "Phone",
                    "Email",
                    "User"
                ]
            },
            afterIcon: {
                enum: [
                    "Phone",
                    "Email",
                    "User"
                ],
                // @ts-ignore
                "enumNames": [
                    "Phone",
                    "Email",
                    "User"
                ]
            }
        }
    },
    field: {
        type: "text",
    }
}
